const getPeriodsFromConfig = (defaultPeriods, config = {}, allPeriodsList) => {
  const { excludedPeriods = [], includedPeriods = defaultPeriods } = config;

  if (excludedPeriods.length) {
    return allPeriodsList.filter((period) => !excludedPeriods.includes(period));
  }

  return allPeriodsList.filter((period) => includedPeriods.includes(period));
};

export default getPeriodsFromConfig;
